import React from "react"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import SideBarLayout from "../../../layout/side-bar-layout"
import { Box, Paper, Stack, Typography } from "@mui/material"
import CodeViewer from "../../../components/CodeViewer/code-viewer"

const SideBarLayoutDocPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Layout - SideBar`

    const codeBasicUsage = `import SideBarLayout from "src/v2/layout/side-bar-layout"

const MinhaPagina = () => {
  const TITLE_PAGE = "C2P | Dashboard"

  return (
    <SideBarLayout
      title={TITLE_PAGE}
      header
      headerTitle="Dashboard"
      headerImage="/backgrounds/dashboard-header.png"
    >
      {/* Conteúdo principal da página */}
      <Paper>
        <Box p={3}>
          <Typography variant="h6" color="common.white">
            {\\\`Conteúdo da página\\\`}
          </Typography>
        </Box>
      </Paper>
    </SideBarLayout>
  )
}`

    const codePropsType = `type SideBarLayoutProps = {
  children: React.ReactNode
  title?: string              // Título da aba/navegador (document.title)
  header?: boolean            // Exibe ou não o header padrão
  headerTitle?: string        // Título exibido no Header
  headerImage?: string        // URL da imagem de fundo do Header
}`

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>

                    {/* INTRO + EXEMPLO PRINCIPAL */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`SideBarLayout`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {`O SideBarLayout é o layout padrão da aplicação. Ele aplica o tema global (ThemeProvider), a SideBar lateral, o Header opcional no topo e configura o título da página (document.title). Todas as páginas principais devem ser envolvidas por esse layout para manter consistência visual e estrutural.`}
                            </Typography>

                            <Box mt={3}>
                                <Typography variant="h6" gutterBottom color="common.white">
                                    {`Exemplo principal`}
                                </Typography>

                                <Typography variant="body2" color="text.secondary" paragraph>
                                    {`Exemplo de uso do SideBarLayout com header ativo, título da página e imagem de fundo no header.`}
                                </Typography>

                                <Paper variant="outlined">
                                    <Box p={2}>
                                        <CodeViewer code={codeBasicUsage} language="jsx" />
                                    </Box>
                                </Paper>
                            </Box>
                        </Box>
                    </Paper>

                    {/* ESTRUTURA DO LAYOUT */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Estrutura do layout`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Internamente o SideBarLayout aplica o ThemeProvider com o tema padrão, CssBaseline, os componentes de sessão (SessionTimeout e RefreshToken) e organiza a página em duas colunas: a SideBar fixa à esquerda e o conteúdo principal à direita. Quando a prop header é verdadeira, o Header é exibido no topo, e o conteúdo (children) é deslocado para baixo respeitando a altura do header.`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {`O container principal usa display: "flex", gap entre a SideBar e o conteúdo, plano de fundo padrão e altura mínima de 100vh, garantindo que a área útil ocupe toda a viewport.`}
                            </Typography>
                        </Box>
                    </Paper>

                    {/* PROPRIEDADES DO COMPONENTE */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades do componente`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Principais propriedades expostas pelo SideBarLayout. Propriedades adicionais não são repassadas; o layout serve como contêiner de alto nível para as páginas.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <Typography variant="subtitle2" gutterBottom color="common.white">
                                        {`Tipo das props (exemplo em TypeScript`}
                                        {`)`}
                                    </Typography>
                                    <CodeViewer code={codePropsType} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default SideBarLayoutDocPage